module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Scene":{"widgets.sceneViewer.widgets.currentRating.handleDom.rate.eventChecker":[{"value":function (argument) {
return fox.site.member ? true : false;
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101008},"path":"~.SitePage_Scene","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/rating.js
// module id = 704
// module chunks = 4